import React from "react";
import { fmtDate, labelize } from "@/lib/constants";

/** Right-hand status timeline for a bad-lead report. */
export default function BadLeadStatusHistory({ history }) {
  return (
    <div className="brut-card p-5">
      <div className="font-chivo font-bold uppercase tracking-tight mb-3">Status history</div>
      <ol className="border-l-2 border-black ml-2">
        {(history || []).map((h) => (
          <li key={h.at || `${h.status}-${h.by || ""}`} className="ml-3 mb-3">
            <div className="text-[11px] font-mono text-zinc-500">{fmtDate(h.at)}</div>
            <div className="font-mono text-sm">{labelize(h.status)}</div>
            <div className="text-xs">{h.by_name || "system"} {h.notes && `· ${h.notes}`}</div>
          </li>
        ))}
      </ol>
    </div>
  );
}
